import { createFileRoute } from "@tanstack/react-router";

import { SpecialtiesUnifiedClient } from "@/components/admin/specialties/specialties-unified-client";

/**
 * Admin → Specialties.
 *
 * V1.1 P1 — D21 STRICT 1:1 port of legacy `src/app/admin/specialties/specialties-unified-client.tsx`
 * (~3236 LOC) + tabs/insurance-tab.tsx (~434 LOC). 7-tab admin: global / country /
 * services / insurance / synonyms / symptoms / SEO specialty.
 *
 * Replaces V1.0 LEAN stub (was: list + edit-in-legacy link).
 *
 * Adapter conventions inherited:
 *  - useAdminFetch → apiFetch
 *  - next-intl useTranslations → Lingui Trans/t macros
 *  - useSearchParams + router.replace → TanStack Router useSearch + useNavigate
 *  - dbTarget (legacy dual-DB) hardcoded local-to-prod (V1.1 follow-up)
 *  - showToast + getActiveLangs ported to apps/admin
 *  - SeoDetailModal ported to apps/admin
 */

interface SpecialtiesSearch {
  country?: string;
  tab?:
    | "global"
    | "specialties"
    | "services"
    | "insurance"
    | "synonyms"
    | "symptoms"
    | "seoSpecialitati";
}

const VALID_TABS = [
  "global",
  "specialties",
  "services",
  "insurance",
  "synonyms",
  "symptoms",
  "seoSpecialitati",
] as const;

// Legacy URLs used `?tab=country` for the per-country specialties view —
// transparently rename to `specialties` so old bookmarks still resolve.
function normalizeTabParam(raw: unknown): SpecialtiesSearch["tab"] {
  if (typeof raw !== "string") return undefined;
  if (raw === "country") return "specialties";
  return VALID_TABS.includes(raw as (typeof VALID_TABS)[number])
    ? (raw as SpecialtiesSearch["tab"])
    : undefined;
}

export const Route = createFileRoute("/_authenticated/specialties")({
  component: SpecialtiesUnifiedClient,
  validateSearch: (search: Record<string, unknown>): SpecialtiesSearch => ({
    country: typeof search.country === "string" ? search.country : undefined,
    tab: normalizeTabParam(search.tab),
  }),
});
